import { useTranslation } from "react-i18next";
import { CheckIcon, TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { ConfirmationModal } from "../../ConfirmationModal";
import { Tag } from "../../../models/Tags";

interface Props {
    info: {
        show: boolean;
        tag?: Tag;
    };
    onClose: () => void;
    deleteTag: (tag: Tag) => void
}

export const AgencyDeleteTagModal: React.FC<Props> = ({
    info,
    onClose,
    deleteTag
}) => {

    const { t } = useTranslation();

    const onDeleteTag = () => {
        deleteTag(info.tag!)
        onClose();
    };

    return(
        <ConfirmationModal 
            label={t("DELETE_TAG")}
            isDeleteConfirm={true}
            isOpen={info.show}
            onClose={onClose}
            cancelButton={{ label: t("CLOSE"), icon: <XMarkIcon />, onClick: onClose, }}
            saveButton={{ label: t("DELETE"), icon: <TrashIcon />, onClick: onDeleteTag }}
        >
            <div className='w-full flex flex-wrap items-center justify-center'>
                <label className="text-lg font-semibold py-4 px-2 text-center">
                    {t('DELETE_TAG_MESSAGE', {label: info.tag?.label})}
                </label>
            </div>
        </ConfirmationModal>
    )
}